import React, { useEffect, useState, useRef } from 'react';
import Button from '../../ui/Button';
import styles from './Step1Topic.module.css';
import { functions }  from "../../../firebase/firebase.js";
import { getCallableCache } from "../../../hooks/getCallableCachedPromisData";
import { getFunctions, httpsCallable } from 'firebase/functions';
import  { getItemsByFeedTitleKeyword, getItemsByFeedTitleKeywords } from "../../../utils/rssFeeds/rssFeeds";
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi2';

export default function Step1Topic({ custopic, faqs, data, onChange, onNext }) {
  const [topics, setTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [customDescription, setCustomDescription] = useState('');
  const [manualMode, setManualMode] = useState(false);
  const [manualTitle, setManualTitle] = useState('');
  const carouselRef = useRef(null);
  const progressRef = useRef(null);
  const {  id, title, url, description, thumbnail } = custopic;
  
   useEffect(() => {
	  async function loadRSS() {
		const keyword = ['world'];
		const matchedItems = await getItemsByFeedTitleKeywords(keyword, 10);
		setTopics(matchedItems);
	  }

	  loadRSS();
  }, []);

  useEffect(() => {
    const match = topics.find(t => t.link === selectedTopic);
    if (match?.description) {
      setCustomDescription(match.description);
    }
    if (match?.title) {
      setManualTitle(match.title);
    }
  }, [selectedTopic]);
  
  useEffect(() => {

    if (description) {
      setCustomDescription(description);
    }
    if (title) {
      setManualTitle(title);
	  setManualMode(true);
    }
	
  }, [title]);

  const scroll = (dir) => {
    const cardWidth = carouselRef.current.firstElementChild.offsetWidth + 16;
    carouselRef.current.scrollBy({ left: dir * cardWidth, behavior: 'smooth' });
  };

  const updateProgress = () => {
    if (!carouselRef.current) return;
    const { scrollLeft, scrollWidth, offsetWidth } = carouselRef.current;
    const pct = (scrollLeft / (scrollWidth - offsetWidth)) * 100;
    progressRef.current.style.width = `${pct}%`;
  };

  const handleNext = () => {
    if (manualMode && manualTitle.trim() && customDescription.trim()) {
      //onNext({ topic: manualTitle.trim(), description: customDescription.trim(), manual: true });
	  onChange(prev => ({ topic: manualTitle.trim(), source: 'manual', url: url != undefined ? url : '', description: customDescription.trim()}));
	  onNext();
    } else if (selectedTopic && customDescription.trim()) {
        //onNext({ topic: selectedTopic, description: customDescription.trim(), manual: false });
		onChange(prev => ({ topic: manualTitle.trim(), source: 'rss', url: selectedTopic, description: customDescription.trim()}));
		onNext();
    }
  };

  return (
    <div className={styles.container}>
      <h2>Choose or Create a Debate Topic</h2>

      <label className={styles.toggle}>
        <input
          type="checkbox"
          checked={manualMode}
          onChange={(e) => {
            setManualMode(e.target.checked);
            if (e.target.checked) {
              setSelectedTopic(null); // clear RSS selection
            }
          }}
        />
        Use Manual Topic Entry
      </label>

      {!manualMode && (
        <>
          <div className={styles.carouselWrapper}>
            <Button variant="ghost" className={styles.navBtn} onClick={() => scroll(-1)}><HiChevronLeft /></Button>
            <div
              className={styles.carousel}
              ref={carouselRef}
              onScroll={updateProgress}>
              {topics.map((t, i) => (
                <div
                  key={i}
                  className={`${styles.card} ${selectedTopic === t.link ? styles.selected : ''}`}
                  style={{ backgroundImage: `url(${t.thumbnail || ''})` }}
                  onClick={() => setSelectedTopic(t.link)}>
                  <div className={styles.overlay}>
                    <h3>{t.title}</h3>
                    <p>{t.description}</p>
                    <Button variant="secondary" className={styles.btn}>Select</Button>
                  </div>
                </div>
              ))}
            </div>
            <Button variant="ghost" className={styles.navBtn} onClick={() => scroll(1)}><HiChevronRight /></Button>
          </div>

          <div className={styles.progressBar}>
            <div ref={progressRef} className={styles.progress} />
          </div>
        </>
      )}

      {(selectedTopic || manualMode) && (
        <div className={styles.manualInput}>
          <h3>Choose a topic</h3>
		  <input
            type="text"
            placeholder="Debate topic goes here"
            value={manualTitle}
            onChange={(e) => setManualTitle(e.target.value)}
            className={styles.textInput}
          />
        </div>
      )}

      {(selectedTopic || manualMode) && (
        <div className={styles.summaryBox}>
          <h3>Describe This Debate</h3>
          <textarea
            className={styles.textArea}
            placeholder="Summarize the context or issue being debated..."
            value={customDescription}
            onChange={(e) => setCustomDescription(e.target.value)}
            rows={4}
          />
        </div>
      )}

      <div className={styles.summaryBox}>
        <div className={styles.faqSection}>{faqs([])}</div>
	    </div>
      
	   <div className={styles.nextbutton}> 
		   <Button
			  className={styles.nextBtn}
			  variant="primary"
			  onClick={handleNext}
			  disabled={manualMode ? !(manualTitle.trim() && customDescription.trim()) : !(selectedTopic && customDescription.trim())}
		   >
			Next
		  </Button>
	  </div>

    </div>
  );
}

